import React from 'react';
import "react-router-dom";
import '../styles/island.css';

import '../functions/player';

import { AlertBox } from './alertBox';

import { Company } from './company';
import { Government } from './government';
import { Market } from './market';
import { Supplier } from './supplier';
import { Plot } from './plot';
import { City } from './city';
import { Lighthouse } from './lighthouse';

import { EntityCity } from '../classes/EntityCity';
import { EntityCompany } from '../classes/EntityCompany';
import { EntitySupplier } from '../classes/EntitySupplier';
import { EntityGovernment } from '../classes/EntityGovernment';
import { EntityMarket } from '../classes/EntityMarket';

const Entities = {
	stad1: new EntityCity({
    name: "Groenburgh",
    funds: 1200,
		startingFunds: 1200,
    mwuNecessity: 18,
    residents: 5000,
		company: "Bizniz Company",
		color: "rgb(53,198,249)",
		image: "City blue",
		imageStyle: {
			width: "13.9%",
			left: "68.8%",
			bottom: "54.8%",
			transform: `translate(-17.5%, 10.5%)`,
		},
		hudStyle: {
			width: "82.5%",
			transform: `translateY(-10.5%)`
		},
		slots: [{
			image: "Icon - add decentral",
			imageStyle: {
				width: "2.1%",
				left: "72.8%",
				bottom: "60.05%",
			}
		}, {
			image: "Icon - add decentral",
			imageStyle: {
				width: "2.1%",
				left: "77.1%",
				bottom: "63.9%",
			}
		}],
	}),
	stad2: new EntityCity({
    name: "Bronnendal",
    funds: 650,
		startingFunds: 650,
    mwuNecessity: 10,
    residents: 3000,
		company: "Corporation Int.",
		color: "rgb(248, 157, 58)",
		defaultOwned: [4],
		image: "City orange",
		imageStyle: {
			width: "13.9%",
			left: "29.3%",
			bottom: "31.6%",
			transform: `translate(-17.5%, 10.5%)`,
		},
		hudStyle: {
			width: "82.5%",
			transform: `translateY(-10.5%)`
		},
		slots: [{
			image: "Icon - add decentral",
			imageStyle: {
				width: "2.1%",
				left: "33.3%",
				bottom: "36.9%",
			}
		}, {
			image: "Icon - add decentral",
			imageStyle: {
				width: "2.1%",
				left: "37.5%",
				bottom: "40.75%",
			}
		}],
	}),

	company1: new EntityCompany({
    name: "Bizniz Company",
    funds: 1200,
		startingFunds: 1200,
    mwuNecessity: 18,
    employees: 2500,
		location: "Groenburgh",
		color: "rgb(53,198,249)",
		image: "Company blue",
		imageStyle: {
			width: "13.9%",
			left: "81.4%",
			bottom: "54.8%",
			transform: `translate(-17.4%, 19.6%)`,
		},
		hudStyle: {
			width: "82.6%",
			transform: `translateY(-19.6%)`
		},
		slots: [{
			image: "Icon - add decentral",
			imageStyle: {
				width: "2.1%",
				left: "83.1%",
				bottom: "58.1%",
			}
		}, {
			image: "Icon - add decentral",
			imageStyle: {
				width: "2.1%",
				left: "86.5%",
				bottom: "58.1%",
			}
		}],
	}),
	company2: new EntityCompany({
    name: "Corporation Int.",
    funds: 900,
		startingFunds: 900,
    mwuNecessity: 14,
    employees: 1500,
		location: "Bronnendal",
		color: "rgb(248, 157, 58)",
		image: "Company orange",
		imageStyle: {
			width: "13.9%",
			left: "16.6%",
			bottom: "31.6%",
			transform: `translate(-17.4%, 19.6%)`,
		},
		hudStyle: {
			width: "82.6%",
			transform: `translateY(-19.6%)`
		},
		slots: [{
			image: "Icon - add decentral",
			imageStyle: {
				width: "2.1%",
				left: "18.3%",
				bottom: "34.7%",
			}
		}, {
			image: "Icon - add decentral",
			imageStyle: {
				width: "2.1%",
				left: "21.7%",
				bottom: "34.7%",
			}
		}],
	}),

  supplier1: new EntitySupplier({
    name: "Wellectric",
    funds: 600,
		color: "rgb(203,198,49)",
		defaultOwned: [7],
		image: "Supplier",
		imageStyle: {
			width: "12%",
			left: "54.5%",
			bottom: "43%",
			transform: `translate(-13.6%, 21.7%)`,
 		},
		slots: [{
			image: "Plot-internal",
			imageStyle: {
				width: "9.4%",
				left: "45.4%",
				bottom: "43%",
			}
		}, {
			image: "Plot-internal",
			imageStyle: {
				width: "9.4%",
				left: "65%",
				bottom: "43%",
			}
		}],
		hudStyle: {
			width: "86.4%",
			transform: `translateY(-21.7%)`
		}

  }),
  supplier2: new EntitySupplier({
    name: "Sonnelect",
    funds: 750,
		color: "rgb(78,167,72)",
		defaultOwned: [13, 15],
		image: "Supplier",
		imageStyle: {
			width: "12%",
			left: "29.3%",
			bottom: "12%",
			transform: `translate(-13.6%, 21.7%)`,
		},
		slots: [{
			image: "Plot-internal",
			imageStyle: {
				width: "9.4%",
				left: "20.2%",
				bottom: "12%",
			}
		}, {
			image: "Plot-internal",
			imageStyle: {
				width: "9.4%",
				left: "39.9%",
				bottom: "12%",
			}
		}],
		hudStyle: {
			width: "86.4%",
			transform: `translateY(-21.7%)`
		}
  }),

  government: new EntityGovernment({
    name: "Overheid",
		color: "rgb(157,192,207)",
		image: "Government",
		imageStyle: {
			width: "12.4%",
			left: "76.2%",
			bottom: "29.2%",
			transform: `translate(-14.7%, 21.1%)`,
		},
		hudStyle: {
			width: "85.3%",
			transform: `translateY(-21.1%)`
		}
  }),
  market: new EntityMarket({
    name: "De markt",
		funds: 0,
		color: "rgb(157,192,207)",
		image: "Market",
		imageStyle: {
			width: "20.2%",
			left: "74.5%",
			bottom: "1%",
		},
		hudStyle: {
			width: "61.5%",
			transform: `translate(-45%, -25%)`
		}
  }),
};

export const EntitiesArray = [Entities.stad1, Entities.stad2, Entities.company1, Entities.company2, Entities.supplier1, Entities.supplier2, Entities.government, Entities.market];

export class Island extends React.Component {
	constructor(props){
		super(props);

		this.state = {
			curRound: 0
		};

		this.handlePurchase = this.handlePurchase.bind(this);
		this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
	}

	componentWillMount() {
		this.props.percentageGreen(this.getIslandGreen());
	}

	componentDidMount() {
		setTimeout(
	    function() {
				if(this.refs.length > 0){
					this.updateAllPlayers();
				}
	    }
	    .bind(this),
	    200
		);
	}

	changeRound = (rnd) => {
		return Promise.all(EntitiesArray.map((entity, i) => {
			if(EntitiesArray[i].type === "company"){
				return EntitiesArray[i].roundChange(rnd, EntitiesArray);
			} else {
				return EntitiesArray[i].roundChange(rnd);
			}
		}));
	}

	getIslandGreen = () => {
		return Math.floor(EntitiesArray.reduce((accumilator, current) => {return current.getPercentageGreen() + accumilator}, 0) / 6);
	}

	updateAllPlayers = () => {
		for (var i = 0; i < EntitiesArray.length; i++) {
			let ref = "ref_"+EntitiesArray[i].name;
			this.refs[ref].updateVariables();
		}
		this.props.percentageGreen(this.getIslandGreen());
		this.updatePlots(4);
	}

	updatePlots = (num) => {
		const baseRef = "ref_plot_";
		for (var i = 0; i < num; i++) {
			this.refs[baseRef + i].updateVariables();
		}
	}

	async componentWillReceiveProps(nextProps) {
	  if (nextProps.round !== this.state.curRound) {
	    await this.setState({ curRound: nextProps.round });
		await this.changeRound(nextProps.round);
		await this.updateAllPlayers();
	  }
	}

	handlePurchase(obj){
		if(obj.market !== undefined){
			const amount = parseInt(obj.market, 10);

			EntitiesArray[7].funds += (amount * 0.2);
		}
		this.updateAllPlayers();
	}

	addAlert = (msg) => {
		this.setState({
			alerts: <AlertBox handleAlertClose={
				() => { this.setState({alerts: null}) }
			} title="Er ging iets mis" text={msg}/>,
		})
	}

  render() {
    return(
      <div className="gameWrap">
				<City handleAlert={this.addAlert} handlePurchase={this.handlePurchase} entities={EntitiesArray} roadDir="align-right" object={EntitiesArray[1]} ref={"ref_"+EntitiesArray[1].name}/>
				<Company handleAlert={this.addAlert} handlePurchase={this.handlePurchase} entities={EntitiesArray} object={EntitiesArray[3]} ref={"ref_"+EntitiesArray[3].name}/>
				<Supplier front={true} handleAlert={this.addAlert} handlePurchase={this.handlePurchase} entities={EntitiesArray} object={EntitiesArray[4]} ref={"ref_"+EntitiesArray[4].name}/>
				<Supplier front={false} handleAlert={this.addAlert} handlePurchase={this.handlePurchase} entities={EntitiesArray} object={EntitiesArray[5]} ref={"ref_"+EntitiesArray[5].name}/>
				<Government handleAlert={this.addAlert} handlePurchase={this.handlePurchase} object={EntitiesArray[6]} ref={"ref_"+EntitiesArray[6].name}/>
				<Market handleAlert={this.addAlert} handlePurchase={this.handlePurchase} object={EntitiesArray[7]} ref={"ref_"+EntitiesArray[7].name}/>
				<City handleAlert={this.addAlert} handlePurchase={this.handlePurchase} entities={EntitiesArray} roadDir="align-left" object={EntitiesArray[0]} ref={"ref_"+EntitiesArray[0].name}/>
				<Company handleAlert={this.addAlert} handlePurchase={this.handlePurchase} entities={EntitiesArray} object={EntitiesArray[2]} ref={"ref_"+EntitiesArray[2].name}/>
				<Plot handleAlert={this.addAlert} handlePurchase={this.handlePurchase} marine={true} entities={EntitiesArray} ref="ref_plot_0" id="0"/>
				<Plot handleAlert={this.addAlert} handlePurchase={this.handlePurchase} marine={true} entities={EntitiesArray} ref="ref_plot_1" id="1"/>
				<Plot handleAlert={this.addAlert} handlePurchase={this.handlePurchase} marine={false} entities={EntitiesArray} ref="ref_plot_2" id="2"/>
				<Plot handleAlert={this.addAlert} handlePurchase={this.handlePurchase} marine={false} entities={EntitiesArray} ref="ref_plot_3" id="3"/>
				<Lighthouse location='west' coordinates={[13.2, 28.1]}/>
				<Lighthouse location='south'coordinates={[63.6, 14.9]}/>
				<Lighthouse location='north' coordinates={[65.0, 64.8]}/>
				<Lighthouse location='east' coordinates={[92.2, 46.6]}/>
				{this.state.alerts}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/island.js